export type Country = 'bg' | 'ro'
export type Currency = 'BGN' | 'RON'
export type Language = 'bg' | 'ro' | 'en'

export type UserData = {
    id: string
    email: string
    name: string
    organization: {
        organizationId: number
        country: string
        name: string
        qrId: string
        stripeAccountId: string
        stripeProductId: string
    }
    country: Country
    currency: Currency
    phone: string
    onboarding: {
        completed: boolean
        next_action?: {
            id: string
            params?: {
                link?: string
            }
        }
    }
}

export const currencyByCountry: Record<Country, Currency> = {
    'bg': 'BGN',
    'ro': 'RON',
}
